import E9QuickSearch from '../ecology9/E9QuickSearch';

const E8QuickSearch = (props) => {
    return (
        <div className="e8header-quick-search">
            <E9QuickSearch {...props}/>
        </div>
    );
};

export default E8QuickSearch;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8QuickSearch.js